<script setup lang="ts">
/**
 * Osello wordmark as a link — the header / footer brand mark.
 *
 * The SVG itself lives in `LogoMark.vue`, which also owns the `.logo__mark`
 * sizing and the sparkle/dot hover animation (keyed off `.logo:hover` here).
 * Color comes from `currentColor`: set `color` on the container, never hardcode
 * fills or apply CSS filters.
 *
 * Always a link, never an <h1>.
 */
import LogoMark from '@/components/www/layout/LogoMark.vue'

withDefaults(defineProps<{
    to?: string
    label?: string
}>(), {
    to: '/',
    label: 'Osello home',
})
</script>

<template>
  <RouterLink class="logo" :to="to" :aria-label="label">
    <LogoMark/>
  </RouterLink>
</template>

<style>
.logo {
    display: inline-flex;
    align-items: center;
    /* Brand-green by default; header/footer override via `color`.
       Drives the SVG via currentColor — no hardcoded fills, no filter. */
    color: var(--primary-500);
    line-height: 0;
}
</style>
